// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { TraceContext } from '@imprivata-cloud/common/types';
import {
  createSpanName,
  instrument,
  SpanComponent,
} from '@imprivata-cloud/common';
import { getTraceContext as buildTraceContext } from '../../tracing/traceContext';

export class OtelSection {
  getTraceContext = instrument(
    createSpanName(SpanComponent.SERVICE, 'get_trace_context'),
    (_: string, callback: (traceContext: TraceContext) => void) => {
      callback(buildTraceContext());
    },
  );
}
